import { useIntersection } from 'react-use';

import { useListingPageComponentRefs } from '@/hooks/useListingPageComponentRefs';
import { useListing } from '@/hooks/queries/useListing';

import { ShareButton } from '../ShareButton/ShareButton';
import { FavoriteButton } from '../FavoriteButton/FavoriteButton';
import { BackButton } from '../BackButton/BackButton';

import styles from './ActionBar.module.css';

export const ActionBar = () => {
  const { actionBarRef } = useListingPageComponentRefs();
  const { data } = useListing();
  const intersection = useIntersection(actionBarRef, {
    rootMargin: '-1px 0px 0px 0px',
    threshold: 1,
  });

  const isSticky = intersection !== null && !intersection.isIntersecting;

  return (
    <div className={styles.actionBar} data-testid="expose-action-bar" ref={actionBarRef} data-sticky={isSticky}>
      <div className={styles.inner}>
        <div className={styles.backButtonDesktop}>
          <BackButton shouldShowLabel testId="expose-back-button-desktop" />
        </div>
        <div className={styles.backButtonMobile}>
          <BackButton shouldShowLabel={!isSticky} testId="expose-back-button-mobile" />
        </div>
        <div className={styles.buttonGroupDesktop} data-testid="expose-action-bar-desktop-button-group">
          <ShareButton usesLinkComponent />
          {data.listing && <FavoriteButton usesLinkComponent listing={data.listing} />}
        </div>
        <div className={styles.buttonGroupMobile} data-testid="expose-action-bar-mobile-button-group">
          <ShareButton />
          {data.listing && <FavoriteButton listing={data.listing} />}
        </div>
      </div>
    </div>
  );
};
